import { Platform, NativeModules } from 'react-native';

// Get this from RevenueCat Dashboard → Project → API Keys → Public app-specific keys
// iOS key starts with "appl_", Android starts with "goog_"
export const REVENUECAT_IOS_KEY = 'appl_your_ios_key_here';

// The entitlement identifier you create in RevenueCat dashboard
export const ENTITLEMENT_PRO = 'pro';

// The product identifier — must match exactly what you create in App Store Connect
// Format: com.yourapp.productid
export const PRODUCT_ID_PRO_MONTHLY = 'slate_pro_monthly';
export const PRODUCT_ID_PRO_ANNUAL = 'slate_pro_annual';

export function isRevenueCatPlatform() {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

let Purchases = null;

function getPurchases() {
  if (Purchases) return Purchases;
  // Only require if the native module is actually linked
  if (!NativeModules.RNPurchases) return null;
  try {
    const pkg = require('react-native-purchases');
    if (pkg?.default?.configure) Purchases = pkg.default;
  } catch {}
  return Purchases;
}

export async function setupRevenueCat(userId) {
  if (!isRevenueCatPlatform()) return;
  const P = getPurchases();
  if (!P) return;
  try {
    await P.configure({ apiKey: REVENUECAT_IOS_KEY, appUserID: userId });
  } catch (err) {
    console.warn('RevenueCat setup failed:', err.message);
  }
}

export async function getProPackage() {
  const P = getPurchases();
  if (!P) return null;
  try {
    const offerings = await P.getOfferings();
    return offerings?.current?.availablePackages?.[0] ?? null;
  } catch (err) {
    console.warn('RevenueCat getOfferings failed:', err.message);
    return null;
  }
}

export async function purchasePro() {
  const P = getPurchases();
  if (!P) throw new Error('RevenueCat not initialized');
  const pkg = await getProPackage();
  if (!pkg) throw new Error('No package available. Make sure your App Store Connect product is approved and linked in RevenueCat.');
  const { customerInfo } = await P.purchasePackage(pkg);
  return customerInfo.entitlements.active[ENTITLEMENT_PRO] != null;
}

export async function restorePurchases() {
  const P = getPurchases();
  if (!P) throw new Error('RevenueCat not initialized');
  const customerInfo = await P.restorePurchases();
  return customerInfo.entitlements.active[ENTITLEMENT_PRO] != null;
}

export async function checkProEntitlement() {
  const P = getPurchases();
  if (!P) return false;
  try {
    const customerInfo = await P.getCustomerInfo();
    return customerInfo.entitlements.active[ENTITLEMENT_PRO] != null;
  } catch {
    return false;
  }
}
